import { Component, Input } from '@angular/core';
import { IhmLink } from './ihm-link.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'ihm-link',
  templateUrl: './ihm-link.component.html',
  styleUrls: ['./ihm-link.component.scss']
})
export class IhmLinkComponent {
  @Input() link: IhmLink;
  @Input() showLinkNames = true;
  @Input() tooltipDisabled = false;

  constructor(private router: Router) {}

  defaultClickHandler(): void {}
}
